<app-popup>
  <div class="inner">
    <span class="default-cross" (click)="onClose()"></span>
    <div class="title">Изменение пароля</div>
    <form class="form" [formGroup]="form">
      <div class="item" [class.error]="oldPasswordCtrl.touched && oldPasswordCtrl.errors || (oldPasswordCtrl.errors && submitting)">
        <label for="oldPassword" class="label required">старый пароль</label>
        <input type="password" class="input" id="oldPassword" [formControl]="oldPasswordCtrl"
               placeholder="введите старый пароль">
        <span class="error-message" *ngIf="oldPassword && oldPasswordCtrl.errors"><span class="lnr lnr-warning"></span>{{oldPassword}}</span>
      </div>
      <div class="item" [class.error]="newPasswordCtrl.touched && newPasswordCtrl.errors || (newPasswordCtrl.errors && submitting)">
        <label for="newPassword" class="label required">новый пароль</label>
        <input type="password" class="input" id="newPassword" [formControl]="newPasswordCtrl"
               placeholder="введите новый пароль">
        <span class="error-message align-block" *ngIf="newPasswordCtrl.touched && newPasswordCtrl.errors"><span
          class="lnr lnr-warning vertical-align"></span><span class="error-message-text"> Пароль слишком простой (мин. 6 символов, обязательно цифры и буквы)</span></span>
      </div>
      <div class="item"
           [class.error]="(approvePasswordCtrl.value !== newPasswordCtrl.value && approvePasswordCtrl.touched) || (approvePasswordCtrl.touched && approvePasswordCtrl.errors) || (approvePasswordCtrl.errors && submitting)">
        <label for="approvePassword" class="label required">подтвердите новый пароль</label>
        <input type="password" class="input" id="approvePassword" [formControl]="approvePasswordCtrl"
               placeholder="еще раз">
        <!--<span  class="error-message" *ngIf="approvePasswordCtrl.touched && approvePasswordCtrl.errors"> пароль слишком простой (мин. 6 символов, обязательно цифры и буквы)</span>-->
      </div>
      <div class="error-message"
           *ngIf="approvePasswordCtrl.touched && approvePasswordCtrl.touched && approvePasswordCtrl.value !== newPasswordCtrl.value && newPasswordCtrl.value && newPasswordCtrl.value">
     <span
       class="lnr lnr-warning"></span> Введенные пароли не соответствуют
      </div>
      <div class="error-message"
           *ngIf="errorMessage">
        {{errorMessage}}
      </div>
    </form>

    <div class="buttons-wrapper">
      <button class="button blue-btn" (click)="onClose()">
        Отмена
      </button>
      <button class="button red-btn" (click)="onSubmit()"
              [disabled]="submitPressed || (!form.valid && submitting) || (approvePasswordCtrl.value !== newPasswordCtrl.value && submitting)">
        Сменить
      </button>
    </div>
  </div>
</app-popup>
